module.exports = __webpack_public_path__ + "img/组 131@2x.f6fc8549.png";